import type { InsightListContent } from './insightListContent'
import { ListGroupCard } from './ListGroupCard'
import { RelationshipsCard } from './RelationshipsCard'
import { InsightCardRenderer } from './InsightCardRenderer'
import { CategoryBreakdownCard } from './CategoryBreakdownCard'
import type { RenderPage } from '../../../insightRenderPresentation'

/** Bounded kind dispatch, never feature IDs, metric formulas or inferred layouts. */
/** Optional app content stays inside its exact list row, including the full-list modal. */
export function InsightPageRenderer({ page, listContent }: { page: RenderPage; listContent?: InsightListContent }) {
  const sections = page.sections.map((section) => {
    let content
    if (section.kind === 'cards') content = <InsightCardRenderer presentation={section.presentation} />
    else if (section.kind === 'list-group')
      content = <ListGroupCard group={section} content={listContent?.[section.id]} />
    else if (section.kind === 'category-breakdown') content = <CategoryBreakdownCard card={section} />
    else if (section.kind === 'relationship-list') {
      const { id: _id, ...presentation } = section
      content = <RelationshipsCard presentation={presentation} />
    } else content = <s-banner tone="critical">{section.error.message}</s-banner>
    return (
      <div key={section.id} id={section.id} tabIndex={-1}>
        {content}
      </div>
    )
  })
  return (
    <s-stack gap="large" data-insight-page>
      {sections}
    </s-stack>
  )
}
